import { render, staticRenderFns } from "./activity_detail.vue?vue&type=template&id=5838ed82&scoped=true"
import script from "./activity_detail.vue?vue&type=script&lang=js"
export * from "./activity_detail.vue?vue&type=script&lang=js"
import style0 from "./activity_detail.vue?vue&type=style&index=0&id=5838ed82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838ed82",
  null
  
)

export default component.exports